"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendFollowUpPrescription = void 0;
const native_base_1 = require("native-base");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const hooks_1 = require("../../../../store/hooks");
const reducers_1 = require("../../../../store/reducers");
const User_service_1 = __importDefault(require("../../../../services/User.service"));
const Breakpoints_1 = require("../../../../helper/Breakpoints");
const organisms_1 = require("../../../organisms");
const AbortFUPModal_1 = require("./AbortFUPModal");
const followUpPrescriptionSlice_1 = require("../../../../store/reducers/followUpPrescriptionSlice");
const lodash_1 = __importDefault(require("lodash"));
const GlobalStyles_1 = require("../../../../helper/GlobalStyles");
const InputLoader_1 = __importDefault(require("../../../atome/InputLoader/InputLoader"));
//@ts-ignore
function SendFollowUpPrescription(props) {
    const { navigation, setCurrentPage, showFUPRModal, setShowFUPRModal } = props;
    const userInformation = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const prescriptionInfo = (0, hooks_1.useAppSelector)(reducers_1.selectPrescriptionInfo);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const lastMedicationID = userInformation?.medication[userInformation?.medication.length - 1].id;
    const [submitButtonLoading, setSubmitButtonLoading] = (0, react_1.useState)(false);
    const handleBackButton = () => {
        let reducerType = {
            type: '[UPDATE]',
            payload: {
                followUpPrescriptionsIndex: prescriptionInfo?.medicationAvailable === 'changeMedication' ? 10 : 9,
            },
        };
        setCurrentPage(reducerType);
    };
    const preparaDataForSending = () => {
        const finalData = lodash_1.default.cloneDeep(prescriptionInfo);
        finalData.generalSideEffects =
            prescriptionInfo.generalSideEffects.toString();
        finalData.psychologicalSideEffects =
            prescriptionInfo.psychologicalSideEffects.toString();
        finalData.medicationId = lastMedicationID;
        return finalData;
    };
    const save = async () => {
        const preparedDataForSending = preparaDataForSending();
        setSubmitButtonLoading(true);
        const response = await User_service_1.default.followPrescription(preparedDataForSending);
        setSubmitButtonLoading(false);
        if (response.error) {
            console.error(response.message);
        }
        if (!response.error) {
            let reducerType = {
                type: '[UPDATE]',
                payload: {
                    followUpPrescriptionsIndex: 12,
                },
            };
            dispatch((0, reducers_1.setPrescriptionInfo)(followUpPrescriptionSlice_1.initialState));
            setCurrentPage(reducerType);
        }
    };
    (0, react_1.useEffect)(() => {
        console.log('PRESCRIPTION INFO', prescriptionInfo);
    }, [prescriptionInfo]);
    return (react_1.default.createElement(react_native_1.SafeAreaView, null,
        react_1.default.createElement(native_base_1.ScrollView, { bgColor: "#fff", h: "100%", w: "100%" },
            Breakpoints_1.isDesktop && react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
            react_1.default.createElement(native_base_1.VStack, { space: 5, alignItems: 'center', style: GlobalStyles_1.globalStyles.mobileToWebContainer },
                react_1.default.createElement(native_base_1.Center, { w: "100%", mt: "20" },
                    react_1.default.createElement(native_base_1.Text, { fontSize: "2xl", textAlign: "center", fontWeight: "bold", color: "#3db384" }, "Jetzt Folgerezept anfordern")),
                react_1.default.createElement(native_base_1.Center, { w: "100%", mt: "3" },
                    react_1.default.createElement(native_base_1.Text, null, "Sie k\u00F6nnen Ihren Folgerezeptantrag nun abschicken."),
                    react_1.default.createElement(native_base_1.Text, { my: "5", textAlign: "center", w: "80%" }, "Die behandelnden \u00C4rzte pr\u00FCfen diesen in der Regel innerhalb von 2 Werktagen. Sie erhalten eine R\u00FCckmeldung per E-Mail."),
                    react_1.default.createElement(native_base_1.Text, { color: "#979797", mt: "10", textAlign: "center", w: "80%" },
                        react_1.default.createElement(native_base_1.Text, { bold: true }, "Hinweis:"),
                        " Bitte beachten Sie, dass die Bearbeitung und der Postversand an Wochenenden und Feiertagen vereinzelt l\u00E4nger dauern kann.")),
                react_1.default.createElement(native_base_1.HStack, { space: 4, justifyContent: "space-around", mb: "10" },
                    react_1.default.createElement(native_base_1.Button, { mt: "12", w: "40%", alignSelf: 'center', backgroundColor: '#fff', borderRadius: "3xl", _text: { color: '#3db384', fontWeight: 'bold', underline: true }, onPress: handleBackButton }, "Zur\u00FCck"),
                    react_1.default.createElement(native_base_1.Button, { disabled: submitButtonLoading, mt: "12", alignSelf: 'center', backgroundColor: submitButtonLoading ? 'rgba(61, 179, 132, .5)' : '#3db384', borderRadius: "3xl", _text: { color: '#fff', fontWeight: 'bold' }, onPress: save, paddingLeft: "25px", paddingRight: "25px" },
                        react_1.default.createElement(native_base_1.HStack, null,
                            submitButtonLoading && react_1.default.createElement(InputLoader_1.default, null),
                            react_1.default.createElement(native_base_1.Text, { marginLeft: "5px", color: "#ffffff", fontWeight: "bold" }, "Jetzt abschicken"))))),
            react_1.default.createElement(AbortFUPModal_1.AbortFUPModal, { navigation: navigation, setCurrentPage: setCurrentPage, showFUPRModal: showFUPRModal, setShowFUPRModal: setShowFUPRModal }))));
}
exports.SendFollowUpPrescription = SendFollowUpPrescription;
